import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ul>
                <li>
                  Land use analysis: Temporal analysis was performed over the
                  KMA region with 10 km buffer for 2000, 2004, 2009, 2014, and
                  2019. <a href="#_bookmark18"> 14.5 and 14.6</a> depict the
                  land use map and percentage coverage of each land use class
                  over the study region. A three-fold rise in urban class was
                  observed across the study area with an infill type of
                  development in the core of the metropolitan and development or
                  swelling of urban pockets in the buffer especially in the
                  North direction. It was observed that the alterations were at
                  the cost of vegetation and others category. Over the years,
                  vegetation and others category have reduced drastically by 18%
                  and 13.82%. However, the water classes have increased slightly
                  due to the complete utilization of available landscape that is
                  dedicated to the Eastern wetlands (Ramsar site).
                </li>
                <li>
                  Land Surface Temperature: Land Surface Temperature for the
                  metropolitan with 10 km buffer was quantified, as shown in{" "}
                  <a href="#_bookmark19"> 14.7</a>. It was observed that the
                  mean LST of the region has increased from 19.15 to 29.74
                  <sup>◦</sup>
                  C. The minimum and maximum surface temperature of the study
                  area has also experienced a significant rise. Post this, a
                  classwise analysis was performed wherein each land use class
                  was extracted, and LST corresponding to them was calculated.{" "}
                  <a href="#_bookmark20">Fig. 14.8</a>illustrates the minimum,
                  maximum, and mean values of surface temperature and estimated
                  CoV for understanding variation due to each land use class and
                  within each of the class. It was observed that the highest
                  surface temperature corresponds to urban class, followed by
                  others and vegetation category. Water class including ponds,
                  lakes, wetlands, aquaculture, and river
                </li>
              </ul>
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh5.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              FIGURE 14.5 Land use maps for KMA with 10 km buffer.
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh6.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <br /> FIGURE 14.6 Classwise statistical analysis of LST from the
              study area.
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh7.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              FIGURE 14.7 Temporal land surface temperature maps for KMA with 10
              km Buffer.
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh8.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <br /> FIGURE 14.8 Classwise statistical analysis of LST from the
              study area.
            </p>
            <p>&nbsp;</p>
            <p>
              corresponded to minimum surface temperature. It was visible from
              the results that each land use class has experienced a rise in
              minimum, maximum, and mean surface temperature. Rise in LST for
              urban class can be explained with the changes in the land use
              where there has been a significant rise observed in urban area,
              and these areas have high heat storage capacity. Rise in LST of
              vegetation and other class can be explained by the reduction in
              density of vegetation and breathing spaces. The rise in LST of
              water bodies can be inferred to the increased area of wetlands
              because these have higher surface temperature than other deeper
              water bodies.
            </p>
            <p>
              <ul>
                <li>
                  Normalized Urban Heat Island Index (NUHII): NUHII obtained was
                  then reclassified into six classes wherein first class
                  represented negative heat islands and rest of them with the
                  increasing class value corresponded to increased positive The
                  reclassified NUHII for the study area is shown in{" "}
                  <a href="#_bookmark21">Fig. 14.9</a> and it was found that
                  most of the anthropogenic constructions exhibit positive UHIs.
                  The highest values were observed in the core region and few
                  urban pockets toward the western part due to increased
                  developments. More than half of the urban area has NUHII value
                  of 0.1e0.3 that affects more than 70% of the residents.
                  One-tenth of the study region was observed to experience very
                  high positive heat islands. Approximately 80% of the core part
                  of metropolitan was observed to have a positive UHI that can
                  be inferred to the domination of urban surface over any other
                  class. Percentage area cover under each class is as shown in{" "}
                  <a href="#_bookmark22">Table 14.3</a>.
                </li>
                <li>
                  Derivation of relationship between LU and LST: The LU and LST
                  maps obtained in the study for 2019 were examined to
                  comprehend surface temperatures corresponding to each LU
                  class.
                </li>
              </ul>
            </p>
            <p>
              A transact A-B was considered across LU map, and temperature
              profile graph was created as illustrated in{" "}
              <a href="#_bookmark23">Fig. 14.10</a>. It was observed that high
              value or the crest signifies the presence of urban or others
              category while moderate/low values or dips correspond to the
              presence of vegetation and water bodies, respectively. It can be
              inferred that presence of vegetation and water bodies in the
              region can help in regulating the microclimate of the region,
              while construction of impervious surfaces or leaving surface bare
              can lead to a rise in the surface temperatures.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh9.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              FIGURE 14.9 NUHII for KMA region with 10 km buffer for 2019.
            </p>

            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} colspan="4" width="541">
                    <p>Table 14.3 UHI type and percentage cover.</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="139">
                    <p>Category</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>Range</p>
                  </td>
                  <td style={styles.cell} width="147">
                    <p>UHI type</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>Percentage coverage</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="139">
                    <p>1</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>&lt;0</p>
                  </td>
                  <td style={styles.cell} width="147">
                    <p>Negative</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>19.18</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="139">
                    <p>2</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>0e0.1</p>
                  </td>
                  <td style={styles.cell} width="147">
                    <p>Weak</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>39.45</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="139">
                    <p>3</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>0.1e0.2</p>
                  </td>
                  <td style={styles.cell} width="147">
                    <p>Low</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>30.78</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="139">
                    <p>4</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>0.2e0.3</p>
                  </td>
                  <td style={styles.cell} width="147">
                    <p>Moderate</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>8.55</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="139">
                    <p>5</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>0.3e0.4</p>
                  </td>
                  <td style={styles.cell} width="147">
                    <p>High</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>1.64</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="139">
                    <p>6</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>&gt;0.4</p>
                  </td>
                  <td style={styles.cell} width="147">
                    <p>Extreme</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>0.40</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <h5>4.&nbsp;Mitigation measures</h5>
            <p>
              There are several criteria at the building level, neighborhood
              level, community level, building design level, and meso-town level
              that can help in reducing the overall UHI effect by reducing the
              surface temperatures. Few of them includes understanding the ratio
              of building height to width of the street, the orientation of the
              building, reflectivity of the surface, conductivity of materials,
              and the presence of urban cooling spaces. Some necessary
              mitigation measures that can be considered for reducing the
              overall LST and UHI in the city are as follows:
            </p>
            <p>
              Shading: Providing provision of shading on building entries,
              streets, and public ventures with the help of artificial
              structures or greenery.
              <br />
              <br />
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh10.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <br /> FIGURE 14.10 Temperature profile graph for KMA considering
              10 km buffer.
            </p>

            <p>
              Mini forest: Dedicating a small area for vegetation and planting
              native species of trees in every
            </p>
            <p>
              Development of gardens: Considering that the free space available
              is small, then it can be converted into parks or community
              gardens.
            </p>
            <p>
              Water-sensitive urban design: Developing ponds, pools, and
              fountains in every locality or installation of hybrid systems such
              as wind towers and sprinklers. Another advantage associated with
              this measure is that it improves the aesthetics and beauty of the
              locality.
            </p>
            <p>
              Building design and planning: Introduction of cool roofs and green
              roof can reduce the overall heat storage. Avoiding dark color
              paints and using high reflectivity materials for building
              exteriors can be implemented as a part of the design. Another
              design intervention can be construction of vertical gardens on the
              external surface of building walls.
            </p>
            <p>
              Road infrastructure: Constructing road with cooler material
              instead of asphalt or painting roads with white color can increase
              the reflectivity and reduce the overall heat storage capacity.
            </p>
            <p>
              Creation of pollution-free zones: Few areas and the city&rsquo;s
              main markets can have no vehicle policy, i.e., a complete ban on
              vehicles throughout the day or for a few hours.
            </p>
            <p>
              Green power generation: Government can introduce some incentives
              for green power generation at the individual level or can even set
              up a few power generation plants that use a cleaner source of
            </p>
            <p>
              Behavior change: Outreach program and other strategies can be
              created to make people environmentally educated. These programs
              can be associated with
            </p>
            <p>
              <ul>
                <li>
                  Reduction in the usage of private cars along with promoting
                  carpooling and public transport
                </li>
                <li>
                  Teaching residents to avoid misuse of electricity/power and
                  other available resources
                </li>
                <li>
                  Installation of a cleaner source of energy at individual,
                  community, or city level
                </li>
              </ul>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
